import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class LandPurposesApi extends ApiModule {
	constructor() {
		super(ModulesMap.LAND_PURPOSES, {
			entity: 'land_purposes',
		})
	}
}
